import React from 'react';
import { GameSettings } from '../SettingsModal';
import usePageTranslation from '../../../../../shared/hooks/usePageTranslation';

interface NotificationsSettingsTabProps {
  settings: GameSettings;
  saveSettings: (updates: Partial<GameSettings>) => void;
}

const NotificationsSettingsTab: React.FC<NotificationsSettingsTabProps> = ({ settings, saveSettings }) => {
  const { t } = usePageTranslation('game', 'SettingsModal');
  
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-white mb-4">{t('notifications.title')}</h3>
      
      <div className="bg-gray-800/50 rounded-lg p-4 space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-300 font-medium">{t('notifications.emailNotifications.label')}</p>
            <p className="text-sm text-gray-400">{t('notifications.emailNotifications.description')}</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={settings.emailNotifications}
              onChange={(e) => saveSettings({ emailNotifications: e.target.checked })}
              className="sr-only peer"
            />
            <div className="w-14 h-7 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-indigo-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-300 font-medium">{t('notifications.newsletter.label')}</p>
            <p className="text-sm text-gray-400">{t('notifications.newsletter.description')}</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={settings.newsletter}
              onChange={(e) => saveSettings({ newsletter: e.target.checked })}
              className="sr-only peer"
            />
            <div className="w-14 h-7 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-indigo-600"></div>
          </label>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-300 font-medium">{t('notifications.inGameNotifications.label')}</p>
            <p className="text-sm text-gray-400">{t('notifications.inGameNotifications.description')}</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={settings.inGameNotifications}
              onChange={(e) => saveSettings({ inGameNotifications: e.target.checked })}
              className="sr-only peer"
            />
            <div className="w-14 h-7 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-indigo-600"></div>
          </label>
        </div>

      </div>
    </div>
  );
};

export default NotificationsSettingsTab;

